'use strict';

require('../modules/graph/behaviors/resizes.js');
require('../modules/graph/mixins/calculatedMargin.js');
require('../modules/graph/utils.js');
require('../modules/graph/block.js');
require('../modules/graph/graph.js');
require('../modules/graph/bar-graph.js');
require('../modules/graph/distribution.js');
require('../modules/graph/dot-graph.js');
require('../modules/graph/groupedBar.js');
require('../modules/graph/line.js');
require('../modules/graph/trendsLine.js');
require('../modules/graph/donut.js');
require('../modules/graph/pieChart.js');
require('../modules/graph/spark.js');
require('../modules/graph/sparkbar.js');
require('../modules/graph/sparkline.js');
require('../modules/graph/stackedBar.js');
require('../modules/graph/timeseries.js');
require('../modules/graph/volumebar.js');
require('../modules/graph/xy.js');
